module.exports = __webpack_public_path__ + "img/shadow.e1da9846.svg";